import { render, staticRenderFns } from "./RegisterPage.vue?vue&type=template&id=1b04dc80&scoped=true"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"
import style0 from "./RegisterPage.vue?vue&type=style&index=0&id=1b04dc80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b04dc80",
  null
  
)

export default component.exports